<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Achievement ({{ this.rules.name }})</span>
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-smart-offer-bundle-achievement-type :model.sync="model.type" label="Type"/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
        </v-row>
        <v-expansion-panels>
          <r-guard-panel :model.sync="model.guard" title="Guard Config"/>
          <r-guard-money-panel :model.sync="model.guardMoney" title="Guard Money"/>
        </v-expansion-panels>
        <v-row dense class="mt-3">
          <v-col cols="12" md="4" sm="4">
            <r-currency-kind-dropdown :model.sync="model.currency" />
          </v-col>
          <v-col cols="12" md="4" sm="4" v-if="groups_product_premium.length > 0">
            <r-product-dropdown :model.sync="model.productPremium" :groups="groups_product_premium" label="Product Premium"/>
          </v-col>
          <v-col cols="12" md="4" sm="4" v-if="groups_product_chest.length > 0">
            <r-product-dropdown :model.sync="model.productChest" :groups="groups_product_chest" label="Product Chest"/>
          </v-col>
        </v-row>

        <v-row v-if="type_code === 3">
          <v-col cols="12" md="4" sm="4">
            <r-item-kind-dropdown :model.sync="model.itemKind" label="Item Kind"/>
          </v-col>
        </v-row>

        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-reward-bunch-panel :model.sync="model.reward" title="Rewards" label="Reward" :points="true" :productGroups="groups_product_reward"/>
            <r-reward-bunch-panel :model.sync="model.rewardPremium" title="Rewards Premium" label="Reward" :points="true" v-if="type_code === 3 || type_code === 4"/>
            <r-reward-track-panel :model.sync="model.trackPrize" title="Track Prize" v-if="type_code === 3 || type_code === 5"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ProductGroupKind} from "@/modules/redactor/models/product/ProductGroupKind";
import {SmartOfferBundleAchievement} from "@/modules/redactor/models/smart-offer/bundle-achievement/SmartOfferBundleAchievement";

import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RGuardMoneyPanel from "@/modules/redactor/views/guard/r-guard-money-panel.vue";
import RCurrencyKindDropdown from "@/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue";
import RItemKindDropdown from "@/modules/redactor/views/item-kind/r-item-kind-dropdown.vue";
import RProductDropdown from "@/modules/redactor/views/product/r-product-dropdown.vue";
import RSmartOfferBundleAchievementType from "@/modules/redactor/views/smart-offer/bundle-achievement/r-smart-offer-bundle-achievement-type.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import RRewardTrackPanel from "@/modules/redactor/views/reward/r-reward-track-panel.vue";

export default {
  name: "r-smart-offer-bundle-achievement",
  components: {
    RRewardTrackPanel,
    RRewardBunchPanel,
    RSmartOfferBundleAchievementType,
    RProductDropdown,
    RCurrencyKindDropdown,
    RItemKindDropdown,
    RGuardMoneyPanel,
    RGuardPanel
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    tab: null,
    model: new SmartOfferBundleAchievement(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    type_code() {
      return this.model.type ? this.model.type.id : 0
    },
    groups_product_chest() {
      if (this.type_code === 3) {
        return [ProductGroupKind.SMART_OFFERS];
      } else if (this.type_code === 4) {
        return [ProductGroupKind.SMART_OFFERS];
      } else {
        return [];
      }
    },
    groups_product_premium() {
      if (this.type_code === 1) {
        return [ProductGroupKind.SMART_OFFERS];
      } else if (this.type_code === 3) {
        return [ProductGroupKind.SMART_OFFERS];
      } else if (this.type_code === 4) {
        return [ProductGroupKind.SMART_OFFERS];
      } else {
        return [];
      }
    },
    groups_product_reward() {
      if (this.type_code === 2) {
        return [ProductGroupKind.AVATARS];
      } else {
        return [];
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.tab = null;
      this.rules = rules;
      this.model = model || new SmartOfferBundleAchievement();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      this.save();
    }
  }
}
</script>
